module.exports = __webpack_public_path__ + "static/media/back.297a7160.svg";